import { useEffect } from 'react';
import { bridge } from 'shared/src/utils';

/**
 * 배송지 변경 화면 진입 로깅.
 * 3 플랫폼 공통: VIEW_ADDRESS 단일 발화.
 */
export const useLogViewAddress = () => {
  useEffect(() => {
    bridge.logAnalyticsEvent({
      name: 'VIEW_ADDRESS',
      channel: ['firebase', 'amplitude', 'facebook', 'ablylog'],
      analytics: {
        SCREEN: 'ADDRESS',
      },
    });
  }, []);
};
